// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as MapaRouteImport } from './routes/mapa'
import { Route as CheckEmailRouteImport } from './routes/check-email'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EventosEventIdRouteImport } from './routes/eventos.$eventId'
import { Route as EventoEventIdRouteImport } from './routes/evento.$eventId'
import { Route as ClubSlugRouteImport } from './routes/club.$slug'
import { Route as CafeSlugRouteImport } from './routes/cafe.$slug'
import { Route as AtletaUsernameRouteImport } from './routes/atleta.$username'
import { Route as AuthenticatedPerfilRouteImport } from './routes/_authenticated/perfil'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCafeRouteImport } from './routes/_authenticated/cafe'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedNegociosNuevoClubRouteImport } from './routes/_authenticated/negocios.nuevo-club'
import { Route as AuthenticatedNegociosNuevoCafeRouteImport } from './routes/_authenticated/negocios.nuevo-cafe'
import { Route as AuthenticatedEventsNewRouteImport } from './routes/_authenticated/events.new'
import { Route as AuthenticatedCafePerfilRouteImport } from './routes/_authenticated/cafe.perfil'
import { Route as AuthenticatedCafeDashboardRouteImport } from './routes/_authenticated/cafe.dashboard'
import { Route as AuthenticatedEventoEventIdSeguridadRouteImport } from './routes/_authenticated/evento.$eventId.seguridad'
import { Route as AuthenticatedCafeEventosNuevoRouteImport } from './routes/_authenticated/cafe.eventos.nuevo'
import { Route as AuthenticatedCafeEventosEventIdRouteImport } from './routes/_authenticated/cafe.eventos.$eventId'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const MapaRoute = MapaRouteImport.update({
            id: '/mapa',path: '/mapa',getParentRoute: () => rootRouteImport
          })
const CheckEmailRoute = CheckEmailRouteImport.update({
            id: '/check-email',path: '/check-email',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EventosEventIdRoute = EventosEventIdRouteImport.update({
            id: '/eventos/$eventId',path: '/eventos/$eventId',getParentRoute: () => rootRouteImport
          })
const EventoEventIdRoute = EventoEventIdRouteImport.update({
            id: '/evento/$eventId',path: '/evento/$eventId',getParentRoute: () => rootRouteImport
          })
const ClubSlugRoute = ClubSlugRouteImport.update({
            id: '/club/$slug',path: '/club/$slug',getParentRoute: () => rootRouteImport
          })
const CafeSlugRoute = CafeSlugRouteImport.update({
            id: '/cafe/$slug',path: '/cafe/$slug',getParentRoute: () => rootRouteImport
          })
const AtletaUsernameRoute = AtletaUsernameRouteImport.update({
            id: '/atleta/$username',path: '/atleta/$username',getParentRoute: () => rootRouteImport
          })
const AuthenticatedPerfilRoute = AuthenticatedPerfilRouteImport.update({
            id: '/perfil',path: '/perfil',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCafeRoute = AuthenticatedCafeRouteImport.update({
            id: '/cafe',path: '/cafe',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedNegociosNuevoClubRoute = AuthenticatedNegociosNuevoClubRouteImport.update({
            id: '/negocios/nuevo-club',path: '/negocios/nuevo-club',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedNegociosNuevoCafeRoute = AuthenticatedNegociosNuevoCafeRouteImport.update({
            id: '/negocios/nuevo-cafe',path: '/negocios/nuevo-cafe',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedEventsNewRoute = AuthenticatedEventsNewRouteImport.update({
            id: '/events/new',path: '/events/new',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCafePerfilRoute = AuthenticatedCafePerfilRouteImport.update({
            id: '/perfil',path: '/perfil',getParentRoute: () => AuthenticatedCafeRoute
          })
const AuthenticatedCafeDashboardRoute = AuthenticatedCafeDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedCafeRoute
          })
const AuthenticatedEventoEventIdSeguridadRoute = AuthenticatedEventoEventIdSeguridadRouteImport.update({
            id: '/evento/$eventId/seguridad',path: '/evento/$eventId/seguridad',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCafeEventosNuevoRoute = AuthenticatedCafeEventosNuevoRouteImport.update({
            id: '/eventos/nuevo',path: '/eventos/nuevo',getParentRoute: () => AuthenticatedCafeRoute
          })
const AuthenticatedCafeEventosEventIdRoute = AuthenticatedCafeEventosEventIdRouteImport.update({
            id: '/eventos/$eventId',path: '/eventos/$eventId',getParentRoute: () => AuthenticatedCafeRoute
          })





const AuthenticatedCafeRouteChildren = {
  AuthenticatedCafeDashboardRoute: AuthenticatedCafeDashboardRoute,AuthenticatedCafePerfilRoute: AuthenticatedCafePerfilRoute,AuthenticatedCafeEventosEventIdRoute: AuthenticatedCafeEventosEventIdRoute,AuthenticatedCafeEventosNuevoRoute: AuthenticatedCafeEventosNuevoRoute
}

const AuthenticatedCafeRouteWithChildren = AuthenticatedCafeRoute._addFileChildren(AuthenticatedCafeRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedCafeRoute: AuthenticatedCafeRouteWithChildren,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedPerfilRoute: AuthenticatedPerfilRoute,AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,AuthenticatedNegociosNuevoCafeRoute: AuthenticatedNegociosNuevoCafeRoute,AuthenticatedNegociosNuevoClubRoute: AuthenticatedNegociosNuevoClubRoute,AuthenticatedEventoEventIdSeguridadRoute: AuthenticatedEventoEventIdSeguridadRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AuthRoute: AuthRoute,CheckEmailRoute: CheckEmailRoute,MapaRoute: MapaRoute,PrivacidadRoute: PrivacidadRoute,UnsubscribeRoute: UnsubscribeRoute,AtletaUsernameRoute: AtletaUsernameRoute,CafeSlugRoute: CafeSlugRoute,ClubSlugRoute: ClubSlugRoute,EventoEventIdRoute: EventoEventIdRoute,EventosEventIdRoute: EventosEventIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)